import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isWhiteText, setIsWhiteText] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Load Space Grotesk font
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);

const handleScroll = () => {
  const scrollY = window.scrollY;
  const viewportHeight = window.innerHeight;
  const totalHeight = document.documentElement.scrollHeight;

  if (
    scrollY < viewportHeight || 
    scrollY + viewportHeight >= totalHeight - viewportHeight * 0
  ) {
    setIsWhiteText(true); // top 100vh + bottom 100vh
  } else {
    setIsWhiteText(false); // middle area1
  }
};

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const navLinks = [
    { name: "HOME", link: "/" },
    { name: "ABOUT", link: "/about" },
    { name: "SERVICES", link: "/service" },
    { name: "PORTFOLIO", link: "/portfolio" },
  ];

  return (
    <header className="flex items-center justify-center py-6 px-4 fixed top-0 left-0 right-0 z-50">
      <nav
        className={`backdrop-blur-2xl flex items-center justify-between w-full max-w-2xl rounded-full px-2 py-1.5 transition-all duration-300 ${
          isMenuOpen ? "rounded-2xl" : "rounded-full"
        }`}
        style={{
          background: "rgba(255, 255, 255, 0.08)",
          backdropFilter: "blur(30px)",
          WebkitBackdropFilter: "blur(30px)",
          fontFamily: "'Space Grotesk', sans-serif",
          boxShadow: `
            0 8px 32px rgba(0, 0, 0, 0.18),
            inset 0 1px 1px rgba(255,255,255,0.2),
            inset 0 -1px 1px rgba(255,255,255,0.05)
          `,
          border: "1px solid rgba(255,255,255,0.18)",
          
        }}
      >
        {/* Logo */}
        <div className="bg-white rounded-full px-5 py-1.5 text-black font-bold text-sm tracking-[0.22em]">
          S I N T X
        </div>

        {/* Desktop Nav Links */}
        <ul className="hidden md:flex items-center gap-8 list-none">
  {navLinks.map((item) => {
    const isActive = location.pathname === item.link;

    return (
      <li key={item.name}>
        <a
          href={item.link}
          className="text-xs font-semibold tracking-widest uppercase transition-all duration-300 no-underline"
          style={
            isActive
              ? {
                  background:
                    "linear-gradient(135deg, #129ADC, #B55DD0, #E154AA, #F45A39)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  color: "transparent",
                }
              : {
                  color: isWhiteText ? "#ffffff" : "#000000",
                }
          }
        >
          {item.name}
        </a>
      </li>
    );
  })}
</ul>

        {/* Contact Us Button */}
        {/* <a href="#contact">
  <div className="hidden md:inline-block rounded-full p-[2px] bg-gradient-to-r from-[#129ADC] via-[#B55DD0] via-[#E154AA] to-[#F45A39]">
    <div className="rounded-full px-5 py-1.5 bg-[#101010] hover:bg-[#181818] transition-all duration-300">
      <span
        style={{
          fontFamily: "'Space Grotesk', sans-serif",
          backgroundImage:
            "linear-gradient(135deg, #129ADC, #B55DD0, #E154AA, #F45A39)",
          backgroundClip: "text",
          WebkitBackgroundClip: "text",
          color: "transparent",
          WebkitTextFillColor: "transparent",
          fontWeight: "600",
          fontSize: "0.875rem",
          letterSpacing: "0.05em",
        }}
      >
        Contact Us
      </span>
    </div>
  </div>
</a> */}

<a href="#contact">
  <div className="hidden md:inline-block px-5 py-1.5 rounded-full bg-transparent p-[2px] bg-gradient-to-r from-[#129ADC] via-[#B55DD0] via-[#E154AA] to-[#F45A39] hover:bg-[#101010] transition-all duration-300">
    <span
      style={{
        fontFamily: "'Space Grotesk', sans-serif",
        backgroundImage:
          "linear-gradient(135deg, #129ADC, #B55DD0, #E154AA, #F45A39)",
        backgroundClip: "text",
        WebkitBackgroundClip: "text",
        color: "white",
        WebkitTextFillColor: "white",
        fontWeight: "600",
        fontSize: "0.875rem",
        letterSpacing: "0.05em",
        
      }}
    >
      Contact Us
    </span>
  </div>
</a>


        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="md:hidden flex flex-col items-center justify-center w-10 h-10 rounded-full bg-white/10 backdrop-blur-sm"
          aria-label="Toggle menu"
        >
          <span
            className={`block w-5 h-0.5 rounded-full transition-all duration-300 ${
              isWhiteText ? "bg-white" : "bg-black"
            } ${isMenuOpen ? "rotate-45 translate-y-1.5" : ""}`}
          />
          <span
            className={`block w-5 h-0.5 rounded-full transition-all duration-300 my-1 ${
              isWhiteText ? "bg-white" : "bg-black"
            } ${isMenuOpen ? "opacity-0" : ""}`}
          />
          <span
            className={`block w-5 h-0.5 rounded-full transition-all duration-300 ${
              isWhiteText ? "bg-white" : "bg-black"
            } ${isMenuOpen ? "-rotate-45 -translate-y-1.5" : ""}`}
          />
        </button>
      </nav>

      {/* Mobile Menu Dropdown */}
      <div
        className={`md:hidden absolute left-4 right-4 top-[88px] transition-all duration-300 overflow-hidden ${
          isMenuOpen
            ? "max-h-[400px] opacity-100 visible"
            : "max-h-0 opacity-0 invisible"
        }`}
      >
        <div
          className="backdrop-blur-2xl rounded-2xl p-4"
          style={{
            background: "rgba(0, 0, 0, 0.85)",
            backdropFilter: "blur(30px)",
            WebkitBackdropFilter: "blur(30px)",
            border: "1px solid rgba(255,255,255,0.18)",
          }}
        >
          <ul className="flex flex-col items-center gap-4 list-none mb-4">
            {navLinks.map((item) => (
              <li key={item.name} className="w-full text-center">
                <a
  href={item.link}
  onClick={() => setIsMenuOpen(false)}
  className="block text-xs font-semibold tracking-widest uppercase transition-all duration-200 no-underline py-2"
  style={
    location.pathname === item.link
      ? {
          background:
            "linear-gradient(135deg, #129ADC, #B55DD0, #E154AA, #F45A39)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          WebkitTextFillColor: "transparent",
          color: "transparent",
        }
      : {
          color: "rgba(255,255,255,0.5)",
        }
  }
>
  {item.name}
</a>
              </li>
            ))}
          </ul>

          <div className="inline-block w-full rounded-full p-[2px] bg-gradient-to-r from-[#129ADC] via-[#B55DD0] via-[#E154AA] to-[#F45A39]">
            <div className="rounded-full px-5 py-2 bg-[#101010] hover:bg-[#181818] transition-all duration-300 text-center">
              <span
                style={{
                  fontFamily: "'Space Grotesk', sans-serif",
                  backgroundImage:
                    "linear-gradient(135deg, #129ADC, #B55DD0, #E154AA, #F45A39)",
                  backgroundClip: "text",
                  WebkitBackgroundClip: "text",
                  color: "transparent",
                  WebkitTextFillColor: "transparent",
                  fontWeight: "600",
                  fontSize: "0.875rem",
                  letterSpacing: "0.05em",
                }}
              >
                Contact Us
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}